import { render, staticRenderFns } from "./scrm.vue?vue&type=template&id=3d373fdb&scoped=true"
import script from "./scrm.vue?vue&type=script&lang=js"
export * from "./scrm.vue?vue&type=script&lang=js"
import style0 from "./scrm.vue?vue&type=style&index=0&id=3d373fdb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d373fdb",
  null
  
)

export default component.exports